import { useEffect, useState } from "react";
import { Button, Modal, Skeleton } from "@mantine/core";
import { IconStethoscope, IconExternalLink } from "@tabler/icons-react";
import axios from "axios";
import "./SpecialtiesBanner.css";

export default function SpecialtiesBanner() {
   const [specialties, setSpecialties] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [selected, setSelected] = useState(null);

   useEffect(() => {
      const fetchSpecialties = async () => {
         try {
            const { data } = await axios.get(
               `${process.env.REACT_APP_BACKEND_SERVER}info/specialties/`
            );
            setSpecialties(data);
         } catch (error) {
            console.error("Error fetching specialties:", error);
         } finally {
            setIsLoading(false);
         }
      };
      fetchSpecialties();
   }, []);

   if (isLoading) {
      return <Skeleton height={140} radius="var(--border-radius-lg)" />;
   }

   if (specialties.length === 0) return null;

   return (
      <div className="specialtiesBanner">
         <div className="specialtiesBanner__header">
            <IconStethoscope size={20} className="specialtiesBanner__icon" />
            <h3 className="specialtiesBanner__title">
               Nuestras especialidades
            </h3>
         </div>
         <div className="specialtiesBanner__list">
            {specialties.map((specialty) => (
               <button
                  key={specialty._id || specialty.name}
                  className="specialtiesBanner__item"
                  onClick={() => setSelected(specialty)}
               >
                  <img
                     src={specialty.photo}
                     alt={specialty.name}
                     className="specialtiesBanner__item-image"
                  />
                  <span className="specialtiesBanner__item-name">
                     {specialty.name}
                  </span>
               </button>
            ))}
         </div>

         <Modal
            opened={selected !== null}
            onClose={() => setSelected(null)}
            title={selected?.name}
            centered
            classNames={{
               title: "specialtiesBanner__modal-title",
            }}
         >
            <div className="specialtiesBanner__modal-content">
               <img
                  src={selected?.photo}
                  alt={selected?.name}
                  className="specialtiesBanner__modal-image"
               />
               {selected?.description && (
                  <p className="specialtiesBanner__modal-description">
                     {selected.description}
                  </p>
               )}
               <Button
                  component="a"
                  href={`https://forvet.org/capacitaciones?especialidad=${encodeURIComponent(selected?.name || "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  rightSection={<IconExternalLink size={16} />}
                  color="var(--color-primary)"
                  fullWidth
               >
                  Ver oferta académica
               </Button>
            </div>
         </Modal>
      </div>
   );
}
